module.exports = __webpack_public_path__ + "img/Hogan.30293e9e.svg";